<template>
  <div id="page" :class="{fixed: confirmDialog}">
    <div class="app-content" :class="{show: show}">
      <div class="weui-btn weui-btn_primary btn-create">
        <span class="icon"><i class="iconfont icon-jiahao"></i></span>
        <span class="text" @click="onCreate">创建分享清单</span>
      </div>
      <div class="inventory-list">
        <div class="inventory-item" v-for="item in shareInventory" :key="item.id" @click="onDetail(item.id)">
          <div class="title">{{item.title}}</div>
          <div class="desc">
            <span>{{item.records.length}}件宝贝</span>
            <span>更新时间 {{item.updatedAt}}</span>
          </div>
          <div class="goods">
            <div class="thumb" v-for="record in item.records" :key="record.id"><img :src="record.pict_url" alt=""></div>
          </div>
          <div class="btns">
            <div class="weui-btn weui-btn_ghost" @click.stop="onDelete(item.id)">删除</div>
            <div class="weui-btn weui-btn_primary" @click.stop="onShare(item)">分享</div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="!shareInventory.length">
        <img src="http://cdn.uviewui.com/uview/empty/data.png" alt="">
        <span class="text">您暂未创建清单</span>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
          <p class="weui-toast__content">加载中...</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast weui-toast_text">
          <p class="weui-toast__content">{{toastMsg}}</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showDialogDelete" class="confirm-dialog">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提示</strong></div>
          <div class="weui-dialog__bd">确定删除该分享清单吗？</div>
          <div class="weui-dialog__ft">
            <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="showDialogDelete = false">取消</a>
            <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="onDeleteConfirm">确定</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
#page {
  min-height: 100vh;
}
.app-content {
  height: 100vh;
  overflow-y: auto;
  opacity: 0;
  transition: opacity 0.2s ease;
  background-color: #f7f7f7;
}
.app-content.show {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.2s;
}

.confirm-dialog .weui-dialog__hd {
  padding-bottom: 24px;
}
.confirm-dialog .weui-dialog__btn {
  font-weight: 600;
}
.confirm-dialog .weui-dialog__btn.weui-dialog__btn_primary {
  color: var(--themeColor);
}

.btn-create {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0.24rem;
  width: auto;
  height: 1rem;
  line-height: 1.2;
  background-color: #fff !important;
  color: var(--themeColor);
  border-radius: 8px;
  .icon .iconfont {
    font-size: 16px;
    font-weight: bold;
  }
  .text {
    font-size: 16px;
    padding-left: 0.02rem;
    font-weight: 500;
  }
}

.inventory-list {
  padding: 0 0.24rem;
  .inventory-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 0.28rem;
    .title, .desc {
      text-align: center;
    }
    .title {
      padding-top: 0.34rem;
      height: 0.54rem;
      line-height: 0.54rem;
      font-size: 0.38rem;
      font-weight: 500;
    }
    .desc {
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.26rem;
      color: #999;
    }
    .goods {
      padding: 0.1rem 0.12rem;
      overflow: hidden;
      .thumb {
        float: left;
        width: 25%;
        padding: 0.1rem 0.12rem;
        box-sizing: border-box;
        overflow: hidden;
        margin-bottom: 0.1rem;
        img {
          border-radius: 6px;
        }
      }
    }
    .btns {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      padding-bottom: 0.28rem;
      .weui-btn {
        width: auto;
        font-weight: 400;
        margin: 0 0.28rem 0 0;
        font-size: 0.32rem;
        border-radius: 40px;
        background-color: var(--themeColor);
        border: 1px var(--themeColor) solid;
        padding: 5px 24px;
        height: 34px;
        line-height: 23px;
        &.weui-btn_ghost {
          background-color: #fff;
          color: var(--themeColor);
        }
      }
    }
  }
}

.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  img {
    width: 240px;
  }
  .text {
    font-size: 0.30rem;
    color: #999;
  }
}

</style>

<script>
import request from "../utils/request";
import gfRequest from "../utils/gfRequest";
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      appInfo: {},
      show: false,
      showLoading: true,
      confirmDialog: false,
      showDialogDelete: false,
      showToast: false,
      checkAppKey: false,
      isExpiryAtOut: false,
      shareInventory: [],
      inventoryId: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.global.userInfo
    },
    appEnv() {
      return this.$store.state.global.appEnv
    },
    appColor() {
      return this.$store.state.global.appColor
    },
  },
  created() {
    if (!this.appEnv.prod) {
      const appEnv = {
        prod: this.appEnv.prod,
        appId: 'CC202104110012172897',
        appKey: 'EDF0763043A073BC',
        platformId: 25,
      }
      const userInfo = {
        id: 122551,
        mobile: '18958906820',
        invite_code: "120897",
        avatar: "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLD9jWrnw4j9YFHIKiaE71Pka0Bnz2t8vjcQGax1YibKPLehSjhfqd0uibFziaC1unYb5O80OUI7VDGsQ/132",
        nickname: "文贤",
      };
      this.$store.dispatch('global/commitAppEnv', appEnv)
      this.$store.dispatch('global/commitUserInfo', userInfo)
      new VConsole();
    }
    if (this.appColor) {
      document.body.style.setProperty('--themeColor', this.appColor);
    }
  },
  mounted() {
    const prod = this.appEnv.prod;
    const appEnv = prod ? Object.assign({}, this.appEnv, {appKey: ''}) : this.appEnv;
    const appId = this.$route.query.appid ||'';
    const platformId = this.$route.query.platformid || '';
    if (appId) appEnv.appId = appId;
    if (platformId) appEnv.platformId = parseInt(platformId, 10) || 0;
    if (!appEnv.appId || !appEnv.platformId) {
      this.show = true;
      this.showLoading = false;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    this.$store.dispatch('global/commitAppEnv', appEnv);
    const h5Userinfo = getH5UserInfo();
    if (h5Userinfo) {
      new Promise(async () => {
        await h5Userinfo.then((resp) => {
          const userInfo = JSON.parse(resp);
          console.log('userinfo', userInfo, resp);
          this.$store.dispatch('global/commitUserInfo', userInfo)
        }).catch(err => {
          if (typeof err === 'object') {
            this.toast('未能获取到用户信息请联系客服: ' + JSON.parse(err));
          } else if (typeof err === 'string') {
            this.toast('未能获取到用户信息请联系客服: ' + err);
          }
        });

        let appKey = '';
        this.showLoading = true;
        await checkAppInfo().then(version => {
          appKey = version;
        }).catch((err) => {});
        await this.getTenantCfg(appKey).catch((err) => {});
        await this.getAppInfo().catch((err) => {});
        await this.getShareInventory().catch((err) => {});
        this.show = true;
        setTimeout(() => {
          this.showLoading = false;
        }, 150);
      })
    } else {
      if (!this.appEnv.prod) {
        this.showLoading = true;
        new Promise(async () => {
          await this.getTenantCfg(this.appEnv.appKey).catch((err) => {});
          await this.getAppInfo().catch((err) => {});
          await this.getShareInventory().catch((err) => {});
          this.show = true;
          setTimeout(() => {
            this.showLoading = false;
          }, 150);
        });
      } else {
        this.showLoading = false;
        this.show = true;
        this.toast('未能获取到用户信息请联系客服');
      }
    }
  },
  watch: {
  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.userInfo.id;
    },
    toast(v) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
    },
    onDetail(id) {
      this.$router.push({
        path: '/detail',
        query: {id}
      })
    },
    onDelete(id) {
      this.inventoryId = id;
      this.showDialogDelete = true;
    },
    onShare(record) {
      if (!this.appInfo.shareInventoryPageurl) {
        this.toast('未关联分享站点');
        return;
      }
      shareAction({
        isShow: 1,
        desc: record.desc || (this.userInfo.nickname + '的购物分享清单'),
        thumb: this.appInfo.appLogoImage ? 'https://' + this.appInfo.attachmentBucket + '.' + this.appInfo.attachmentEndpoint + this.appInfo.appLogoImage : '',
        title: record.title,
        contentUrl: `${this.appInfo.shareInventoryPageurl}#/detail?id=${record.id}&appid=${this.appEnv.appId}&appkey=${this.appEnv.appKey}&share=1` ,
      })
    },
    onDeleteConfirm() {
      this.showLoading = true;
      const newRequest = gfRequest({
        url: `/api/share/inventory/${this.inventoryId}`,
        method: 'DELETE',
        data: {
          appid: this.appEnv.appId,
          appkey: this.appEnv.appKey,
          userid: this.userInfo.id,
        }
      });
      newRequest.then((resp) => {
        this.inventoryId = null;
        this.showDialogDelete = false;
        this.getShareInventory().then(() => {
          this.showLoading = false;
        });
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.message);
        }
      })
    },
    onCreate() {
      this.$router.push({
        path: '/form'
      })
    },
    getShareInventory() {
      const newRequest = gfRequest({
        url: `/api/share/inventory`,
        method: 'GET',
        params: {
          appid: this.appEnv.appId,
          appkey: this.appEnv.appKey,
          userid: this.userInfo.id,
        }
      });
      newRequest.then((resp) => {
        this.shareInventory = resp.data || []
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.message);
        }
      })
      return newRequest;
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version }
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, color} = resp;
        const appEnv = this.appEnv
        appEnv.appKey = version;
        this.checkAppKey = appkey === version;
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
        if (color && color.indexOf('#') === 0) {
          document.body.style.setProperty('--themeColor', color);
          this.$store.dispatch('global/commitAppColor', color);
        }
        this.$store.dispatch('global/commitAppEnv', appEnv);
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getAppInfo() {
      const newRequest = gfRequest({
        url: `/api/app/info`,
        method: 'GET',
        params: {appid: this.appEnv.appId, appkey: this.appEnv.appKey }
      });
      newRequest.then((resp) => {
        this.appInfo = resp.data || {};
        this.$store.dispatch('global/commitAppInfo', this.appInfo);
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
  }
}
</script>
